import { typographyEntries } from "./sections/typography";
import { formsEntries } from "./sections/forms";
import { surfaceEntries } from "./sections/surfaces";
import { navigationEntries } from "./sections/navigation";
import { feedbackEntries } from "./sections/feedback";
import { gameSpecificEntries } from "./sections/gameSpecific";

/**
 * Component showcase registry. Entries (render + co-located usage `code`) live
 * in per-group files under ./sections/ — this just concatenates them in group
 * order. To add/edit a component, touch only its section file.
 * See docs/specs/manager-dashboard-component-audit.md.
 */

export const SHOWCASE_GROUPS = [
  "Typography",
  "Forms & buttons",
  "Cards & surfaces",
  "Navigation",
  "Status & feedback",
  "Game-specific",
];

export const componentRegistry = [
  ...typographyEntries,
  ...formsEntries,
  ...surfaceEntries,
  ...navigationEntries,
  ...feedbackEntries,
  ...gameSpecificEntries,
];
